import apiClient from '../client'
import type { PageResponse } from '../types'
import type {
  BankTransferQueryParams,
  BankTransferQueryRowResponse,
  NotificationQueryParams,
  NotificationQueryRowResponse,
} from './types'

export const queriesApi = {
  bankTransfer(params?: BankTransferQueryParams) {
    return apiClient.get<PageResponse<BankTransferQueryRowResponse>>('/api/queries/bank-transfer', { params })
  },

  notification(params?: NotificationQueryParams) {
    return apiClient.get<PageResponse<NotificationQueryRowResponse>>('/api/queries/notification', { params })
  },
}
